window.environmentConfig = {
    REACT_APP_BASE_URL: "https://coldlocker.parityfactory.com",
    REACT_APP_API_URL: "https://coldlocker.parityfactory.com:8090",
}

exports.environmentConfig = window.environmentConfig;